<template>
	<div class="m-drawer" :class="{ open: isOpen }" @click.self="$emit('close')">
		<div class="m-sheet" :class="{ 'm-sheet-product': showProduct }">
			<transition name="fade" mode="out-in">

				<!-- Collection 子菜单 -->
				<MenuProduct
				    v-if="showProduct"
				    class="sheet-content-product"
				    key="product"
				    :tab="currentTab"
				    :section="currentSection"
				    :sectionTitle="currentSectionTitle"
				    :items="currentCategoryItems"
				    @back="closeProduct"
				    @close="$emit('close')"
				/>

				<!-- Info 子菜单 -->
				<MenuSec
					v-else-if="showSec"
					class="sheet-content"
					key="sec"
					:secMenu="secMenu"
					:items="currentInfoItems"
					@back="closeSec"
					@close="$emit('close')"
				/>

				<!-- 主菜单 -->
				<div v-else key="main" class="sheet-content">

					<div class="m-sheet-top">
						<button class="icon-btn" @click="$emit('search')">
							<img
								src="@/assets/icon/search_black.png"
								alt="search"
							/>
						</button>

						<button
							class="icon-btn"
							@click="$emit('close')"
						>
							×
						</button>
					</div>

					<div class="m-tabs">

						<span
							class="tab"
							:class="{
								active: activeTab === 'collection',
								inactive: activeTab !== 'collection'
							}"
							@click="setTab('collection')"
						>
							Collection
						</span>

						<span
							class="tab"
							:class="{
								active: activeTab === 'info',
								inactive: activeTab !== 'info'
							}"
							@click="setTab('info')"
						>
							Info
						</span>

						<span
							class="tab"
							:class="{
								active: activeTab === 'projects',
								inactive: activeTab !== 'projects'
							}"
							@click="setTab('projects')"
						>
							HAHA!
						</span>

					</div>

					<transition name="fade" mode="out-in">

						<!-- Collection -->
						<div
							v-if="activeTab === 'collection'"
							key="collection"
							class="tab-content"
						>

							<div
								v-for="block in collectionBlocks"
								:key="block.title"
								class="m-section"
							>
								<div
									class="m-title"
									@click="goToBy('collection', block.sectionKey)"
								>
									{{ block.title }}
								</div>
							</div>

							<div
								class="m-view-all"
								@click="goToAllCollection"
							>
								VIEW ALL
							</div>

						</div>

						<!-- Info -->
						<div
							v-else-if="activeTab === 'info'"
							key="info"
							class="tab-content"
						>

							<div
								v-for="block in infoBlocks"
								:key="block.title"
								class="m-section"
							>
								<div
									class="m-title"
									@click="openSecMenu(
										block.sectionKey,
										block.title
									)"
								>
									{{ block.title }}
								</div>
							</div>

						</div>

						<!-- Projects -->
						<div
							v-else
							key="projects"
							class="tab-content"
						>

							<div class="m-section">
								<div
									class="m-title"
									@click="goToProjects"
								>
									denHolm United
								</div>
							</div>

						</div>

					</transition>

					<div class="m-bottom-links">

						<a
							class="m-link"
							@click="goToLogin"
						>
							Login
						</a>

						<a
							class="m-link"
							@click="openSubscribe"
						>
							Subscribe
						</a>

					</div>

				</div>

			</transition>
		</div>
	</div>
</template>

<script>
import { getCategoryList } from '@/api/product'
import MenuProduct from './MenuProduct.vue'
import MenuSec from './MenuSec.vue'

import aboutImg from '@/assets/_DSC0544 2 3.jpg'
import founderImg from '@/assets/_DSC0544 2 4.jpg'
import contactImg from '@/assets/_DSC0544 2 4.png'

export default {
	name: 'MobileMenu',

	props: {
		isOpen: {
			type: Boolean,
			default: false
		}
	},

	components: {
		MenuProduct,
		MenuSec
	},

	data() {
		return {

			// 当前 Tab
			activeTab: 'collection',

			// Collection 子菜单是否显示
			showProduct: false,

			// Info 子菜单是否显示
			showSec: false,

			// 当前 Tab
			currentTab: '',

			// 当前 Collection 分类
			currentSection: '',

			// 当前 Info 分类
			secMenu: {
				title: '',
				thirdTitel: ''
			},

			// Collection 一级菜单
			collectionBlocks: [],

			// Collection 数据
			collectionMap: {},

			// Info 一级菜单
			infoBlocks: [
				{
					title: 'ABOUT',
					sectionKey: 'about',
					items: []
				},
				{
					title: 'CONTACT',
					sectionKey: 'contact',
					items: []
				}
			],

			// Info 数据
			infoMap: {
				about: [
					{
						label: 'About Us',
						route: 'About',
						image: aboutImg
					},
					{
						label: 'Founder',
						route: 'Founder',
						image: founderImg
					}
				],

				contact: [
					{
						label: 'Contact',
						route: 'Contact',
						image: contactImg
					}
				]
			},

			// 默认 Collection 一级菜单
			defaultCollectionBlocks: [
				{
					title: 'TABLES',
					sectionKey: 'table'
				},
				{
					title: 'SEATINGS',
					sectionKey: 'seating'
				},
				{
					title: 'ACCESSORIES',
					sectionKey: 'accessories'
				}
			],

			// 默认 Collection 数据
			defaultCollectionMap: {

				table: [
					{
						label: 'Entry Tables',
						CategoryID: 1,
						image: require('@/assets/Group 1-1.png')
					},
					{
						label: 'Console Tables',
						CategoryID: 2,
						image: require('@/assets/Group 1-2.png')
					},
					{
						label: 'Coffee Table',
						CategoryID: 3,
						image: require('@/assets/Group 1-3.png')
					},
					{
						label: 'Side Table',
						CategoryID: 4,
						image: require('@/assets/Group 1-4.png')
					}
				],

				seating: [
					{
						label: 'Chair',
						CategoryID: 5,
						image: require('@/assets/_DSC0544 2 3.png')
					},
					{
						label: 'Stool',
						CategoryID: 6,
						image: require('@/assets/_DSC0544 2 3-1.png')
					}
				],

				accessories: [
					{
						label: 'Planter',
						CategoryID: 7,
						image: require('@/assets/_DSC0544 2 4.jpg')
					},
					{
						label: 'Lighting',
						CategoryID: 8,
						image: require('@/assets/_DSC0544 2 3.png')
					},
					{
						label: 'Mirror',
						CategoryID: 9,
						image: require('@/assets/_DSC0544 2 3-1.png')
					},
					{
						label: 'Hardware',
						CategoryID: 10,
						image: require('@/assets/_DSC0544 2 4.jpg')
					},
					{
						label: 'Decor',
						CategoryID: 11,
						image: require('@/assets/_DSC0544 2 3.png')
					}
				]
			},

			// 默认 Info 数据
			defaultInfoMap: {

				about: [
					{
						label: 'About Us',
						route: 'About',
						image: require('@/assets/_DSC0544 2 3.jpg')
					},
					{
						label: 'Founder',
						route: 'Founder',
						image: require('@/assets/_DSC0544 2 4.jpg')
					}
				],

				contact: [
					{
						label: 'Contact',
						route: 'Contact',
						image: require('@/assets/_DSC0544 2 4.png')
					}
				]

			}
		}
	},

	computed: {

		// 当前 Collection 子菜单数据
		    currentCategoryItems() {
		        return this.collectionMap[this.currentSection] || []
		    },
		
		    // 当前 Collection 分类名称
		    // 名称直接来自接口 CategoryName
		    currentSectionTitle() {
		
		        const current =
		            this.collectionBlocks.find(
		                item =>
		                    item.sectionKey === this.currentSection
		            )
		
		        return current
		            ? current.title
		            : ''
		    },
		
		    // 当前 Info 子菜单数据
		    currentInfoItems() {
		        return this.infoMap[
		            (this.secMenu.thirdTitel || '').toLowerCase()
		        ] || []
		    }
	},

	watch: {

		/**
		 * 菜单打开时：
		 *
		 * 1. 获取 Collection 数据
		 * 2. 尝试恢复浏览器 Back 前保存的菜单状态
		 *
		 * 注意：
		 * 菜单关闭时不能清除 menuState。
		 *
		 * 因为：
		 *
		 * Menu
		 *   ↓
		 * ABOUT
		 *   ↓
		 * About Us
		 *   ↓
		 * 浏览器 Back
		 *   ↓
		 * Menu 自动恢复 ABOUT
		 *
		 * 如果关闭菜单时清掉 menuState，
		 * 浏览器 Back 就无法恢复。
		 */
		isOpen(val) {

			if (val) {

				this.fetchCollectionData()

				this.tryRestore()

			} else {

				this.showProduct = false

				this.showSec = false

				this.currentSection = ''

				/**
				 * 这里不要：
				 *
				 * sessionStorage.removeItem('menuState')
				 *
				 * 否则浏览器 Back 无法恢复。
				 */

			}
		}
	},

	created() {

		this.collectionBlocks =
			this.defaultCollectionBlocks

		this.collectionMap =
			this.defaultCollectionMap

		this.infoMap =
			this.defaultInfoMap

	},

	mounted() {

		if (this.isOpen) {
			this.fetchCollectionData()
		}
window.addEventListener('close-mobile-menu', this.handleGlobalClose)   // ★ 新增
	},
	beforeDestroy() {
		window.removeEventListener('close-mobile-menu', this.handleGlobalClose)   // ★ 新增
	},

	methods: {
handleGlobalClose() {
	sessionStorage.removeItem('menuState')
	
		if (this.isOpen) {
			this.$emit('close')   // → MobileLayout.closeMenu() → menuOpen = false
		}
},
		/**
		 * 尝试恢复菜单状态
		 *
		 * menuState 示例：
		 *
		 * {
		 *   tab: "info",
		 *   section: "about",
		 *   title: "ABOUT",
		 *   returnPath: "/m/home"
		 * }
		 *
		 * 或：
		 *
		 * {
		 *   tab: "collection",
		 *   sectionKey: "table",
		 *   returnPath: "/m/home"
		 * }
		 */
		tryRestore() {

			const raw =
				sessionStorage.getItem('menuState')

			if (!raw) {
				return
			}

			try {

				const state =
					JSON.parse(raw)

				/**
				 * 非常重要：
				 *
				 * 只有浏览器真正返回到
				 * “进入详情页之前的页面”
				 * 才恢复菜单。
				 *
				 * 防止：
				 *
				 * Menu
				 * ↓
				 * About Us
				 *
				 * 进入 About Us 后，
				 * 菜单又自动弹出来。
				 */
				if (
					state.returnPath &&
					this.$route.fullPath !== state.returnPath
				) {
					return
				}

				/**
				 * 当前已经有子菜单时，
				 * 不覆盖用户当前操作。
				 */
				if (
					!this.showProduct &&
					!this.showSec
				) {

					this.restoreState(state)

					/**
					 * 恢复成功后消费掉状态。
					 *
					 * 防止之后普通路由变化时
					 * 再次自动打开菜单。
					 */
					sessionStorage.removeItem(
						'menuState'
					)
				}

			} catch (e) {

				sessionStorage.removeItem(
					'menuState'
				)

			}
		},

		/**
		 * 根据 menuState 恢复菜单
		 */
		restoreState(state) {

			if (!state) {
				return
			}

			this.showProduct = false
			this.showSec = false

			this.activeTab =
				state.tab || 'info'

			/**
			 * Info
			 *
			 * Menu
			 * ↓
			 * Info
			 * ↓
			 * ABOUT
			 * ↓
			 * About Us
			 *
			 * 浏览器 Back
			 *
			 * Menu
			 * ↓
			 * Info
			 * ↓
			 * ABOUT
			 */
			if (state.tab === 'info') {

				this.secMenu = {

					title:
						state.title ||
						(state.section || '').toUpperCase(),

					thirdTitel:
						state.section || ''

				}

				this.showSec = true

			}

			/**
			 * Collection
			 *
			 * Menu
			 * ↓
			 * Collection
			 * ↓
			 * TABLES
			 * ↓
			 * Entry Tables
			 * ↓
			 * Product
			 *
			 * 浏览器 Back
			 *
			 * Menu
			 * ↓
			 * Collection
			 * ↓
			 * TABLES
			 */
			else if (
				state.tab === 'collection'
			) {

				this.currentTab =
					'collection'

				this.currentSection =
					state.sectionKey || ''

				this.showProduct = true

			}
		},

		setTab(tab) {

			this.activeTab = tab

		},

		/**
		 * 获取 Collection 数据
		 */
		async fetchCollectionData() {

			if (this.collectionBlocks.length === 0) {
				this.collectionBlocks = this.defaultCollectionBlocks
				this.collectionMap = this.defaultCollectionMap
			}
			try {
				const response = await getCategoryList()
				const list = Array.isArray(response) ? response : (response.result || [])
				if (!list.length) return
				const blocks = []
				const map = {}
				list.forEach(block => {
					const title = block.CategoryName
					const sectionKey = this.normalizeKey(title)
					blocks.push({ title, sectionKey })
					const items = (block.Items || []).map(item => ({
						key: this.normalizeKey(item.CategoryName),
						label: item.CategoryName,
						CategoryID: item.CategoryID,
						image: item.CategoryImage
					}))
					map[sectionKey] = items
				})
				this.collectionBlocks = blocks
				this.collectionMap = map
			} catch (error) { console.error('Failed to load collection categories:', error) }

		},

		normalizeKey(str) {

			return String(str || '')
				.toLowerCase()
				.replace(
					/[^a-z0-9]+/g,
					'-'
				)
				.replace(
					/^-|-$/g,
					'')

		},

		/**
		 * 打开 Collection 子菜单
		 */
		goToBy(tab, sectionKey) {

			this.currentTab = tab

			this.currentSection =
				sectionKey

			this.showProduct = true

		},

		/**
		 * 打开 Info 子菜单
		 */
		openSecMenu(
			sectionKey,
			title
		) {

			this.secMenu = {

				title,

				thirdTitel:
					sectionKey

			}

			this.showSec = true

		},

		/**
		 * 返回 Collection 一级菜单
		 */
		closeProduct() {

			this.showProduct = false

		},

		/**
		 * 返回 Info 一级菜单
		 */
		closeSec() {

			this.showSec = false

		},

		/**
		 * 查看全部 Collection
		 */
		goToAllCollection() {

			this.$router.push({
				name: 'ProductIndex',
				query: {
					CategoryID: 0
				}
			})

			this.$emit('close')

		},

		/**
		 * Projects
		 */
		goToProjects() {

			window.open(
				'https://www.instagram.com/den_holmunited/',
				'_blank'
			)

		},

		/**
		 * Login
		 */
		goToLogin() {

			this.$router.push(
				'/m/user-info'
			)

			this.$emit('close')

		},

		/**
		 * Subscribe
		 */
		openSubscribe() {

			this.$emit('close')

			window.dispatchEvent(
				new CustomEvent(
					'open-email-popup'
				)
			)

		}

	}
}
</script>

<style scoped>
.m-drawer {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	height: 100vh;
	background: rgba(0, 0, 0, 0);
	z-index: 50;
	pointer-events: none;
	transition: background-color 0.3s ease;
}

.m-drawer.open {
	pointer-events: auto;
}

.m-sheet {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	transform: translateY(100%);
	transition:
		transform 0.3s
		cubic-bezier(
			0.25,
			0.46,
			0.45,
			0.94
		);
	height: 80vh;
	max-height: 80vh;
	border-top: 1rem solid #000;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	background: rgba(255, 255, 255, 1);
	padding-bottom:
		env(
			safe-area-inset-bottom,
			0px
		);
	box-sizing: border-box;
}

.open .m-sheet {
	transform: translateY(0%);
}

.m-sheet.m-sheet-product {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	min-height: 0;
}

.sheet-content-product,
.sheet-content {
	padding: 0;
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.sheet-content {
	padding: 30rem 29rem;
}

.tab-content {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}

.tab-content::-webkit-scrollbar {
	display: none;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.m-sheet-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 42rem;
}

.icon-btn {
	background: none;
	border: none;
	padding: 0;
	width: 28rem;
	height: 28rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 20rem;
	color: #000;
}

.icon-btn img {
	width: 18rem;
	height: 18rem;
}

.m-tabs {
	display: flex;
	justify-content: space-between;
	gap: 10rem;
	align-items: center;
	padding: 0 0 70rem;
}

.tab {
	font-size: 15rem;
	font-weight: 400;
	font-family:
		'Apercu-Medium',
		sans-serif !important;
}

.tab.active {
	color: #000;
}

.tab.inactive {
	color: #bbb;
}

.m-section {
	padding-top: 15rem;
	font-family:
		'Apercu-Medium',
		sans-serif !important;
}

.m-title {
	font-size: 15rem;
	font-weight: 500;
	font-family:
		'Apercu-Medium',
		sans-serif !important;
}

.m-view-all {
	padding: 68rem 0;
	font-size: 15rem;
	font-weight: 500;
	font-family:
		'Apercu-Medium',
		sans-serif !important;
}

.m-bottom-links {
	padding:
		40rem 0
		calc(
			40rem +
			env(
				safe-area-inset-bottom,
				0px
			)
		);
	display: grid;
	gap: 2rem;
	margin-top: auto;
}

.m-link {
	color: #000;
	text-decoration: none;
	font-size: 15rem;
	font-weight: 400;
	font-family:
		'Apercu-Medium',
		sans-serif !important;
}
</style>